import { ARBITRUM, AVALANCHE } from "./chains";

export const SUBGRAPH_URLS = {
  [ARBITRUM]: {
    stats: "https://api.thegraph.com/subgraphs/name/gmx-io/gmx-stats",
    referrals: "https://api.thegraph.com/subgraphs/name/gmx-io/gmx-arbitrum-referrals",
    nissohVault: "https://api.thegraph.com/subgraphs/name/nissoh/gmx-vault",
  },

  [AVALANCHE]: {
    stats: "https://api.thegraph.com/subgraphs/name/davidblockdev/amx-avalanche-stats1",
    // stats: "https://api.thegraph.com/subgraphs/name/hspdev0814/amx_avalanche_trade_info_test",
    referrals: "https://api.thegraph.com/subgraphs/name/davidblockdev/amx-avalanche-referrals",
    trades:"https://api.thegraph.com/subgraphs/name/davidblockdev/polygon-subgraph-avalanche-tra",
  },

  common: {
    chainLink: "https://api.thegraph.com/subgraphs/name/deividask/chainlink",
  },
};
